module.exports = __webpack_public_path__ + "img/my-applications-ico.1645d3c3.svg";